// globals.ts
import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    loader_status:any = true;
}